import type { ReactNode } from 'react';
import { SDK_INFO, type SdkKey } from '@gonfalon/sdk-info/sdkInfo';
import nullthrows from 'nullthrows';

import { trackSdkSetupSnippetClicked } from '../../../analytics';
import { getSdkInitSnippet, type SdkInitKeys } from '../../../utils';
import { SdkSetupSnippet } from '../../SdkSetupSnippet/SdkSetupSnippet';

import { initializationSnippetConfig } from './config';
import type { InitializableSdk } from './types';

interface InitializationProps {
  sdk: InitializableSdk;
  sdkInitKeys: SdkInitKeys;
  memberId: string;
  loading?: boolean;
}

export const isInitializableSdk = (sdk: SdkKey): sdk is InitializableSdk => {
  return sdk in initializationSnippetConfig;
};

export const InitializeSDK = ({ sdk, sdkInitKeys, memberId, loading }: InitializationProps): ReactNode => {
  const { event, title } = initializationSnippetConfig[sdk];
  const snippet = nullthrows(getSdkInitSnippet(sdk, sdkInitKeys, memberId));

  return (
    <SdkSetupSnippet
      withCopyButton
      withLineNumbers
      loading={loading}
      trackAnalyticsOnClick={() => trackSdkSetupSnippetClicked(event)}
      snippets={[{ title, language: SDK_INFO[sdk].prismLang, snippet }]}
    />
  );
};
